var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 16,
  viewBox: "0 0 16 16",
  width: 16,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  fill: "currentColor",
  r: 1,
  transform: "matrix(1 0 0 -1 7 9)"
}))));
export default SvgTarget;